export enum LabelsEnum {
  ready = 'ready',
  confirmation = 'confirmation',
  completed = 'completed',
  next = 'next',
  reminder = 'reminder',
  resconf = 'resconf',
  reply = 'reply',
  chat = 'chat',
  cancellation = 'cancellation',
  rescheckin = 'rescheckin',
  waitlistCancellation = 'waitlistCancellation',
  toGoOrderConfirmation = 'toGoOrderConf',
  toGoOrderReady = 'toGoOrderReady',
}
